import { useEffect, useState } from 'react';

import { LANGUAGE_ENABLED_SESSION_STORAGE_KEY, LANGUAGE_SESSION_STORAGE_KEY } from './constants';

type SSOLanguage = 'en' | 'lt';

export const useLanguage = () => {
    const isAppWithLanguageSwitch =
        typeof window !== 'undefined' &&
        (document.querySelector('.react-app-sso-login') ||
            document.querySelector('.react-app-strong-login') ||
            document.querySelector('.react-app-confirm-bank-registration'));
    const isLanguageSessionEnabled = isAppWithLanguageSwitch
        ? sessionStorage.getItem(LANGUAGE_ENABLED_SESSION_STORAGE_KEY) === 'true'
        : false;
    const sessionLanguage = isAppWithLanguageSwitch
        ? (sessionStorage.getItem(LANGUAGE_SESSION_STORAGE_KEY) as SSOLanguage | null)
        : null;
    const [language, setLanguage] = useState<SSOLanguage | null>(sessionLanguage);

    useEffect(() => {
        const handleLanguageChange = () => {
            setLanguage(sessionStorage.getItem(LANGUAGE_SESSION_STORAGE_KEY) as SSOLanguage);
        };

        window.addEventListener('languageChange', handleLanguageChange);

        return () => {
            window.removeEventListener('languageChange', handleLanguageChange);
        };
    }, []);

    const updateLanguage = (newLanguage: SSOLanguage) => {
        sessionStorage.setItem(LANGUAGE_SESSION_STORAGE_KEY, newLanguage);
        const languageChangeEvent = new CustomEvent('languageChange');
        window.dispatchEvent(languageChangeEvent);
    };

    return {
        language: isLanguageSessionEnabled ? language : undefined,
        setLanguage: updateLanguage,
        isAppWithLanguageSwitch,
    };
};
